import BackendConnector from './backendConnector';

export default class EventTrackingHTTPService {
    static createEventBulk({ events }) {
        return BackendConnector.post('/events/create', { events });
    }
}
